import { render, staticRenderFns } from "./EntityDrawer.vue?vue&type=template&id=a28b2a80&scoped=true"
import script from "./EntityDrawer.vue?vue&type=script&lang=js"
export * from "./EntityDrawer.vue?vue&type=script&lang=js"
import style0 from "./EntityDrawer.vue?vue&type=style&index=0&id=a28b2a80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28b2a80",
  null
  
)

export default component.exports